// TODO: move state in doc type view component with portal target into sidebar
import _ from 'lodash'

export const CLEAR_SIDEBAR_FILTER = 'CLEAR_SIDEBAR_FILTER'

export const SIDEBAR_SET_DEFAULT_FILTER = 'SIDEBAR_SET_DEFAULT_FILTER'
export const SIDEBAR_SET_DEFAULT_LOCATION = 'SIDEBAR_SET_DEFAULT_LOCATION'
export const SIDEBAR_SET_DEFAULT_SUBSIDIARY = 'SIDEBAR_SET_DEFAULT_SUBSIDIARY'

export const SIDEBAR_SET_SELECTED_CONTACT = 'SIDEBAR_SET_SELECTED_CONTACT'
export const SIDEBAR_SET_SELECTED_SUBTYPE = 'SIDEBAR_SET_SELECTED_SUBTYPE'
export const SIDEBAR_SET_SELECTED_MEMBER_UUID = 'SIDEBAR_SET_SELECTED_MEMBER_UUID'
export const SIDEBAR_SET_SELECTED_LOCATION_UUID = 'SIDEBAR_SET_SELECTED_LOCATION_UUID'
export const SIDEBAR_SET_SELECTED_SUBSIDIARY_UUID = 'SIDEBAR_SET_SELECTED_SUBSIDIARY_UUID'

const state = {
    selectedContact: null,
    selectedSubtype: null,

    selectedUserUuid: null,
    selectedLocationUuid: null,
    selectedSubsidiaryUuid: null
}

export const getters = {
    selectedContact: state => state.selectedContact || {},
    selectedSubtype: state => state.selectedSubtype || {},

    selectedUserUuid: state => state.selectedUserUuid,
    selectedLocationUuid: state => state.selectedLocationUuid,
    selectedSubsidiaryUuid: state => state.selectedSubsidiaryUuid,

    getSelectedMember: (state, getters, rootState, rootGetters) => _.find(rootGetters.getMembers, {uuid: state.selectedUserUuid}) || {},
    getSelectedLocation: (state, getters, rootState, rootGetters) => _.find(rootGetters.getLocations, {uuid: getters.selectedLocationUuid}) || {},
    getSelectedSubsidiary: (state, getters, rootState, rootGetters) => _.find(rootGetters.getSubsidiaries, {uuid: getters.selectedSubsidiaryUuid}) || {}
}

export const mutations = {
    [SIDEBAR_SET_SELECTED_CONTACT]: (state, contact) => {
        state.selectedContact = contact
    },
    [SIDEBAR_SET_SELECTED_SUBTYPE]: (state, subtype) => {
        state.selectedSubtype = subtype
    },
    [SIDEBAR_SET_SELECTED_MEMBER_UUID]: (state, uuid) => {
        state.selectedUserUuid = uuid
    },
    [SIDEBAR_SET_SELECTED_LOCATION_UUID]: (state, uuid) => {
        state.selectedLocationUuid = uuid
    },
    [SIDEBAR_SET_SELECTED_SUBSIDIARY_UUID]: (state, uuid) => {
        state.selectedSubsidiaryUuid = uuid
    },
    [CLEAR_SIDEBAR_FILTER]: (state) => {
        state.selectedContact = null
        state.selectedSubtype = null
        state.selectedUserUuid = null
        state.selectedLocationUuid = null
        state.selectedSubsidiaryUuid = null
    }
}

export const actions = {
    [SIDEBAR_SET_DEFAULT_FILTER]: ({dispatch}) => {
        dispatch(SIDEBAR_SET_DEFAULT_LOCATION)
        dispatch(SIDEBAR_SET_DEFAULT_SUBSIDIARY)
    },
    [SIDEBAR_SET_DEFAULT_LOCATION]: ({rootGetters, commit}) => {
        const defaultLocationId = _.get(rootGetters, 'userDefaultLocation.uuid')
        if (defaultLocationId && rootGetters.checkUserHasLocationAccess(defaultLocationId)) {
            commit(SIDEBAR_SET_SELECTED_LOCATION_UUID, defaultLocationId)
        }
    },
    [SIDEBAR_SET_DEFAULT_SUBSIDIARY]: ({rootGetters, commit}) => {
        const defaultSubsidiaryId = _.get(rootGetters, 'userDefaultSubsidiary.uuid')
        if (defaultSubsidiaryId && rootGetters.checkUserHasSubsidiaryAccess(defaultSubsidiaryId)) {
            commit(SIDEBAR_SET_SELECTED_SUBSIDIARY_UUID, defaultSubsidiaryId)
        }
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}
